export default __webpack_public_path__ + "static/media/white-lock.ca3695df.svg";